<template>
    <div>
        <div class="flex justify-center mt-40">
xx            
        </div>
        <div class="flex flex-col items-center mb-48">
            <h3 class="text-3xl font-bold text-blue-600 mt-12">Welcome to the Secondary PE Passport</h3>
            <h3 class="text-2xl text-blue-600">Setting up is fast and easy, let's get started.</h3>
        </div>
    </div>
</template>
<script>
    export default{
        name: "Welcome",
    }
</script>
<style scoped>

</style>